export default __webpack_public_path__ + "static/hero-image-8c78784c4f149c22b10643d141c82a8f.jpg";